import { ModalComponent } from '@propertyfinder/modal';
import { Fragment, h } from 'preact';

import { BackendConfigEnvPlatformEnum } from 'common/data/backend/config/env-platform.enum';
import { PropertyReportTooltipModalTemplatePropsInterface } from 'common/module/property-report/tooltip-modal/template-props.interface';

export const PropertyReportTooltipModalTemplate = ({
  title,
  hideContent,
  children,
  platform,
}: PropertyReportTooltipModalTemplatePropsInterface) => (
  <ModalComponent
    openOnLoad
    bodyClassName={'property-report-2__modal-container'}
    title={title}
    onClose={hideContent}
    showFooter={false}
    fullScreen={platform === BackendConfigEnvPlatformEnum.mobile}
    showOverlay={false}
  >
    <Fragment>{children}</Fragment>
  </ModalComponent>
);
